import component from './index';

import less from '!raw-loader!./index.less';
import templateStr from '!raw-loader!./index';

const getBlockImg = (data) => ({
  name: data.name,
  className: 'img',
  children: {
    wrapper: {
      className: 'img-content',
    },
    img: {
      children: data.img,
    },
  },
});

export default {
  component,
  templateStr,
  less,
  dataSource: {
    wrapper: {
      className: 'home-page-wrapper feature19-wrapper',
    },
    page: {
      className: 'home-page feature19',
    },
    OverPack: {
      playScale: 0.3,
    },
    titleWrapper: {
      className: 'feature19-title-wrapper',
      children: [
        {
          name: 'title',
          className: 'feature19-title-h1',
          children: '战略新兴产业',
        },
      ],
    },
    blockWrapper: {
      className: 'feature19-block-wrapper',
      gutter: 24,
      children: [
        {
          md: 8,
          xs: 24,
          name: 'block1',
          className: 'feature19-block',
          children: {
            className: 'feature19-block-group feature19-block-group1',
            children: [
              {
                name: 'title',
                className: 'feature19-block-title',
                children: '高端装备制造产业',
              },
              {
                name: 'content',
                className: 'feature19-block-content',
                children: '坚持以发展工业机器人、军民融合为重点，以机器人及高档数控机床、智能关键基础零部件、智能测控装置为重要领域，加速打造集群经济。',
              },
            ],
          },
        },
        {
          md: 8,
          xs: 24,
          name: 'block2',
          className: 'feature19-block',
          children: {
            className: 'feature19-block-group feature19-block-group2',
            children: [
              {
                name: 'title',
                className: 'feature19-block-title',
                children: '电子信息产业',
              },
              {
                name: 'content',
                className: 'feature19-block-content',
                children: '打造以物联网、传感器等成长性关联领域，融合新一代信息技术电子产业集群。',
              },
            ],
          },
        },
        {
          md: 8,
          xs: 24,
          name: 'block3',
          className: 'feature19-block',
          children: {
            className: 'feature19-block-group feature19-block-group3',
            children: [
              {
                name: 'title',
                className: 'feature19-block-title',
                children: '新材料产业',
              },
              {
                name: 'content',
                className: 'feature19-block-content',
                children: '聚集各类新材料领域的行业领先企业，建设具有全国影响力的特色新材料产业创新基地',
              },
            ],
          },
        },
      ],
    },
    img: {
      className: 'img-wrapper',
      children: [
        getBlockImg(
          {
            name: 'block0',
            img: 'https://imm.86links.com/assets/landing/feature/Feature12-img/bottom-1.png',
          }
        ),
        getBlockImg(
          {
            name: 'block1',
            img: 'https://imm.86links.com/assets/landing/feature/Feature12-img/bottom-2.png',
          }
        ),
        getBlockImg(
          {
            name: 'block2',
            img: 'https://imm.86links.com/assets/landing/feature/Feature12-img/bottom-3.png',
          }
        ),
      ],
    },
  },
};
